import { Chip, TextField } from "@material-ui/core";
import { Autocomplete, AutocompleteProps } from "@material-ui/lab";
import { useField } from "formik";
import React from "react";
import { enumToLabelMap } from "pages/dashboard/interests/utils";
import { PostgresUserRole } from "types/gql-types";

const RoleLabels: Record<PostgresUserRole, string> = enumToLabelMap(PostgresUserRole);

const RolesInput: React.FC = () => {
  const [field, { error: errors }, { setValue }] = useField<PostgresUserRole[]>("roles");

  const handleChange: AutocompleteProps<PostgresUserRole | PostgresUserRole[] | undefined, false, false, false>["onChange"] = (_, values) => {
    if (!values) {
      setValue([]);
      return;
    }

    setValue(Array.isArray(values) ? values : [values]);
  };

  return (
    <Autocomplete
      multiple
      fullWidth
      options={Object.values(PostgresUserRole)}
      {...field}
      onChange={handleChange}
      getOptionLabel={(option: PostgresUserRole) => RoleLabels[option]}
      renderTags={(tagValue, getTagProps) =>
        tagValue.map((option, index) => (
          <Chip
            key={index}
            style={{ display: "inline flex", flexDirection: "initial" }}
            label={RoleLabels[option]}
            {...getTagProps({ index })}
          />
        ))
      }
      style={{ width: 500 }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Roles"
          placeholder="Roles ..."
          error={!!errors}
          helperText={errors}
          margin="dense"
          variant="outlined"
          fullWidth
        />
      )}
    />
  );
};

export default RolesInput;
